import { useNavigate } from "react-router-dom";
import { useRestorableSelection } from "../../utils/backNavigation";
import User from "../../compoment/icon/User";
import Users from "../../compoment/icon/Users";
import ScreenHeader from "../../compoment/ui/ScreenHeader";
import CircleButton from "../../compoment/ui/CircleButton";
import { ArrowRight, ScanBack } from "../../compoment/icon";

// Stored under "join" and read by later screens (/magic) — keep these exact.
const JOIN_OPTIONS = [
    { value: "I am on my own", Icon: User },
    { value: "I am with my friend", Icon: Users },
] as const;

const JoiningTodayScreen = () => {
    const navigate = useNavigate();
    // Empty when arriving forward; the earlier choice when arriving via Back.
    const [join, setJoin] = useRestorableSelection("join");

    const handleNext = () => {
        if (!join) return;
        localStorage.setItem("join", join);
        navigate("/choose-avatar");
    };

    return (
        <section className="wishScreen wishScreen--joining">
            <ScreenHeader
                leading={
                    <button
                        type="button"
                        className="roundBack"
                        aria-label="Back"
                        onClick={() => navigate("/selected-lantern")}
                    >
                        <ScanBack />
                    </button>
                }
            />

            <main className="wishScreen__copy">
                <h1 className="wishScreen__title">
                    WHO’S JOINING
                    <br />
                    YOU TODAY?
                </h1>
            </main>

            <div className="joinOptions" role="radiogroup" aria-label="Who’s joining you today?">
                {JOIN_OPTIONS.map(({ value, Icon }) => {
                    const selected = join === value;
                    return (
                        <button
                            key={value}
                            type="button"
                            role="radio"
                            aria-checked={selected}
                            className={`joinOption${selected ? " is-selected" : ""}`}
                            onClick={() => setJoin(value)}
                        >
                            <span className="joinOption__icon" aria-hidden="true">
                                <Icon />
                            </span>
                            <span className="joinOption__label">{value}</span>
                        </button>
                    );
                })}
            </div>

            <CircleButton
                label="NEXT"
                icon={<ArrowRight />}
                disabled={!join}
                onClick={handleNext}
            />
        </section>
    );
};

export default JoiningTodayScreen;
